import { IsProd } from "@/constants/config";
import request from "@/utils/request";

const PATH_PREFIX = IsProd ? "/v1/" : "/vb/";

export interface ApiMultiCityCode {
  multicity_code: string;
  description: string;
  airports: string[];
}

export const setMultiCityCode = async (data: ApiMultiCityCode) => {
  const res = await request.post<ApiMultiCityCode, { status: number }>(
    PATH_PREFIX + "user_modify_multicity_code",
    {
      ...data,
    }
  );
  return res.data;
};

export const deleteMultiCityCode = async (multicity_code: string) => {
  const res = await request.post<{ multicity_code: string }, { status: number }>(
    PATH_PREFIX + "user_delete_multicity_code",
    {
      multicity_code,
    }
  );
  return res.data;
};
